/*global require, document, Vue, checkmx, formData, FormData, axios*/
/*jslint this: true*/
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
VeeValidate.Validator.extend("checkmx", checkmx);

import Datepicker from 'element-ui/lib/date-picker';
Vue.use(Datepicker);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example-component', require('./components/ExampleComponent.vue'));

const app = new Vue({
    el: "#contentwrapper",
    data: formData,
    methods: {
        checkFile: function (type) {
            if (type === "sample") {
                this.sampleCheck = document.getElementById("sampleFile").value.length > 0;
            } else if (type === "bio") {
                this.bioCheck = document.getElementById("biosecurityPaperwork").value.length > 0;
            }
        },
        clearFile: function (type) {
            if (type === "sample") {
                document.getElementById("sampleFile").value = "";
                this.$validator.validate('sampleFile', "");
            } else if (type === "bio") {
                document.getElementById("biosecurityPaperwork").value = "";
                this.$validator.validate('biosecurityPaperwork', "");
            }

            this.checkFile(type);
        },
        arrayContains: function (valuesArr, checkArr) {
            if (['Bulk Analysis', 'Compound Specific Analysis (GC-IRMS)'].indexOf(this.sampleAnalyses) >= 0) {
                return valuesArr.filter(function (item) {
                    return checkArr.indexOf(item) >= 0;
                }).length > 0;
            }

            return false;
        },
        validateOnSubmit: function () {
            this.$validator.validateAll().then(function (check) {
                if (check) {
                    // Submit the form if valid
                    document.querySelector('#submissionForm').submit();
                } else {
                    // Jump to first invalid form element
                    this.$el
                        .querySelector('[name="' + this.$validator.errors.items[0].field + '"]')
                        .previousElementSibling.scrollIntoView();
                }
            }.bind(this));
        }
    }
});
